import React from "react";
import PropTypes from "prop-types";
import { IoIosHappy } from "react-icons/io";
import { MdGroups2 } from "react-icons/md";
import { BsPersonFill } from "react-icons/bs";
import "./FeatureSection5.css";

const features = [
  {
    icon: <IoIosHappy />,
    title: "Sentiment analysis",
    description: "Check, for each message, if the text expresses happiness or stress.",
  },
  {
    icon: <MdGroups2 />,
    title: "Tribes",
    description: "Find out to what virtual tribes you belong to, are you a nerd, a spiritualist, a treehugger, or a fatherlander? Are you a bee, an ant or a leech?",
  },
  {
    icon: <BsPersonFill />,
    title: "Personality",
    description: "Explore your big five personality traits: Openness, Conscientiousness, Extroversion, Agreeableness, and Neuroticism.",
  },
];

const FeatureCard = ({ icon, title, description }) => (
  <div className="feature-card" tabIndex="0" aria-label={title}>
    <div className="feature-icon">{icon}</div>
    <h3 className="feature-title">{title}</h3>
    <p className="feature-description">{description}</p>
  </div>
);

FeatureCard.propTypes = {
  icon: PropTypes.element.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
};

const FeatureSection1 = ({ sectionTitle = "Collect data, get insights, know more about your network", sectionSubtitle = "" }) => (
  <section className="feature-section">
    <div className="feature-header">
      <h2 className="title">{sectionTitle}</h2>
      {sectionSubtitle && <p className="section-subtitle">{sectionSubtitle}</p>}
    </div>
    <div className="feature-grid">
      {features.map((feature, index) => (
        <FeatureCard key={index} {...feature} />
      ))}
    </div>
  </section>
);

FeatureSection1.propTypes = {
  sectionTitle: PropTypes.string,
  sectionSubtitle: PropTypes.string,
};

export default FeatureSection1;
